export const SET_EVENT = 'setEvent'
export const SET_START = 'setStart'
export const SET_END = 'setEnd'

export const SET_OFFDATES = 'setOffDates'
